import { Link } from "react-router-dom";
import siteConfig from "../../config/site";
import Footer from "../../Components/Footer/Footer";

const EntertainerCard = ({ performer }) => (
  <div className="rounded-2xl overflow-hidden bg-gray-900/60 border border-purple-900/30 hover:border-purple-600/50 transition-all duration-500 group">
    {/* Placeholder image area */}
    <div className="h-72 sm:h-80 bg-gradient-to-br from-purple-900/40 via-gray-900 to-gray-800 flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
      <span className="text-7xl opacity-40 group-hover:opacity-60 transition-opacity duration-500">💎</span>
      {/* Name overlay at bottom */}
      <div className="absolute bottom-0 left-0 right-0 p-6">
        <h3 className="text-3xl font-bold text-white">
          {performer.name}
        </h3>
        <p className="text-purple-300 text-sm italic mt-1">{performer.tagline}</p>
      </div>
    </div>

    <div className="p-6">
      <p className="text-gray-400 text-sm leading-relaxed mb-2">
        <span className="text-gold font-semibold">Style:</span> {performer.style}
      </p>
      <p className="text-gray-400 text-sm leading-relaxed mb-6">
        {performer.bio}
      </p>
      <Link
        to="/book"
        className="inline-block px-8 py-3 bg-gold text-black font-bold rounded-full hover:bg-gold-light transition-all duration-300 shadow-lg shadow-gold/20"
      >
        Book {performer.name}
      </Link>
    </div>
  </div>
);

const Entertainers = () => {
  const { entertainers } = siteConfig;

  return (
    <div className="bg-[#0a0a0f] min-h-screen">
      {/* Header */}
      <div className="pt-32 pb-16 px-6">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4">
            Our Entertainers
          </h1>
          <div className="w-24 h-0.5 bg-gradient-to-r from-purple-700 to-gold mx-auto mb-6" />
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Each performer brings a unique persona, energy, and artistry to every show. 
            Browse our roster and find the perfect entertainer for your experience.
          </p>
        </div>
      </div>

      {/* Entertainer Grid */}
      <section className="px-6 pb-20">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          {entertainers.map((performer) => (
            <EntertainerCard key={performer.id} performer={performer} />
          ))}
        </div>
      </section>

      {/* Coming Soon */}
      <section className="px-6 pb-12">
        <div className="max-w-3xl mx-auto text-center">
          <div className="p-8 rounded-2xl bg-gray-900/30 border border-gray-800/30">
            <p className="text-gray-500 text-sm uppercase tracking-widest mb-2">Coming Soon</p>
            <p className="text-gray-400 text-base">
              New performers are joining the Exo roster. Follow us for announcements.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 px-6 bg-gradient-to-b from-[#0a0a0f] via-purple-950/10 to-[#0a0a0f]">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            Ready to Book?
          </h2>
          <p className="text-gray-400 mb-6">
            Tell us about your event and we'll match you with the perfect performer.
          </p>
          <Link
            to="/book"
            className="inline-block px-10 py-4 bg-gold text-black font-bold text-lg rounded-full hover:bg-gold-light transition-all duration-300 shadow-lg shadow-gold/30"
          >
            Book Now
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Entertainers;
